import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import {PricePlanDetailsModel} from "../../models/price-plan-details.model";
import {ExportType} from "../../../../commons/types/export.type";
import * as _ from "lodash";

require('./price-plan-details-view.scss');
@Component({
  standalone: false,
  selector: 'app-price-plan-details-view',
  templateUrl: './price-plan-details-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricePlanDetailsViewComponent implements OnChanges {

  @Input() pricePlanDetails: PricePlanDetailsModel;
  @Input() selectedIds: string[];
  @Output() setAsDefaultEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() duplicatePricePlanEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() createPricePlanChildEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() editPricePlanEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() updatePricePlanAccountsEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() importProgramSettingsEvent = new EventEmitter<PricePlanDetailsModel>();
  @Output() onExportEvent = new EventEmitter<{event: any, exportType: ExportType}>();
  @Output() onSelectedIdsChange = new EventEmitter<string[]>();

  public exportTypes: typeof ExportType = ExportType;


  public pricePlanProgramsCount: number;
  public selectedKeys: any;

  constructor() {
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.pricePlanDetails) {
      if (!!this.pricePlanDetails) {
        this.pricePlanProgramsCount = this.pricePlanDetails.entryList?.filter(e => e.enabled)?.length || 0;
      }
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }
  }

  onToggleSelectAll() {
    this.onSelectedIdsChange.emit(this.selectedIds.length ? [] : _.map(this.pricePlanDetails.accountsDetails, 'id'));
  }

  onToggle(accountId, isSelected) {
    const selectedIds = !isSelected ? _.concat(this.selectedIds || [], [accountId]) :
      _.filter(this.selectedIds, (id) => {
        return id !== accountId;
      });

    this.onSelectedIdsChange.emit(selectedIds);
  }


}
